// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  State,
} from "./types";


export default __t.row({
  componentKey: __t.string().primaryKey().name("component_key"),
  get state() {
    return State;
  },
  since: __t.timestamp(),
  reason: __t.string(),
  get overrideState() {
    return __t.option(State).name("override_state");
  },
  overrideReason: __t.string().name("override_reason"),
  lastProbeAt: __t.timestamp().name("last_probe_at"),
  lastOkAt: __t.timestamp().name("last_ok_at"),
  consecutiveFail: __t.u32().name("consecutive_fail"),
  consecutiveOk: __t.u32().name("consecutive_ok"),
  build: __t.string(),
});
